import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { GEL_BREVIER } from '@bbc/gel-foundations/typography';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { visuallyHiddenStyle } from '../utilities';
var C_BLACK = '#000000';
var Figure = /*#__PURE__*/styled.figure.withConfig({
  displayName: "Figure",
  componentId: "sc-7q0enq-0"
})(["background-color:", ";margin:0;"], C_BLACK);
var FigCaption = /*#__PURE__*/styled.figcaption.withConfig({
  displayName: "FigCaption",
  componentId: "sc-7q0enq-1"
})(["", " ", " color:", ";padding:", ";> span{", "}"], function (_ref) {
  var service = _ref.service;
  return getSansRegular(service);
}, GEL_BREVIER, C_WHITE, GEL_SPACING, visuallyHiddenStyle);

var CaptionWrapper = function CaptionWrapper(_ref2) {
  var children = _ref2.children,
      service = _ref2.service,
      textPrefixVisuallyHidden = _ref2.textPrefixVisuallyHidden,
      text = _ref2.text;
  return /*#__PURE__*/React.createElement(Figure, null, children, /*#__PURE__*/React.createElement(FigCaption, {
    service: service
  }, textPrefixVisuallyHidden && /*#__PURE__*/React.createElement("span", null, textPrefixVisuallyHidden), text));
};

CaptionWrapper.defaultProps = {
  textPrefixVisuallyHidden: null
};
CaptionWrapper.propTypes = {
  children: node.isRequired,
  service: string.isRequired,
  textPrefixVisuallyHidden: string,
  text: string.isRequired
};
export default CaptionWrapper;